export default __webpack_public_path__ + "media/images/images_v2/bleufin-liste-3233779cc5d8df01c9aabda085a84938.png";